export default __webpack_public_path__ + "static/source-sans-pro-latin-400-normal-6174cf1de0b4d2d2c6b1ee9e600616a1.woff";